import React from 'react'
import { MdBugReport, MdOutlineEmail, MdOutlinePhone, MdOutlineWeb } from 'react-icons/md'
import config from '../app-config'

export default function Support() {
    return (
        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl p-4 border border-gray-200">
            <div className="text-center mb-3">
                <h3 className="text-base font-bold text-gray-800 mb-1">Need Help?</h3>
                <p className="text-xs text-gray-600">Contact OurCodeLab</p>
            </div>

            <div className="space-y-2">
                <div className="text-center p-2 bg-white rounded-lg shadow-sm">
                    <div className="bg-blue-100 p-1.5 rounded-full w-8 h-8 mx-auto mb-1 flex items-center justify-center">
                        <MdOutlineEmail size={14} color="#3B82F6" />
                    </div>
                    <a
                        href={`mailto:${config.support_email}`}
                        className="text-xs text-blue-600 hover:text-blue-800 transition-colors duration-200 block"
                    >
                        {config.support_email}
                    </a>
                </div>

                <div className="text-center p-2 bg-white rounded-lg shadow-sm">
                    <div className="bg-green-100 p-1.5 rounded-full w-8 h-8 mx-auto mb-1 flex items-center justify-center">
                        <MdOutlinePhone size={14} color="#10B981" />
                    </div>
                    <a
                        href={`tel:${config.support_phone}`}
                        className="text-xs text-green-600 hover:text-green-800 transition-colors duration-200 block"
                    >
                        {config.support_phone}
                    </a>
                </div>
                <div className="text-center p-2 bg-white rounded-lg shadow-sm">
                    <div className="bg-green-100 p-1.5 rounded-full w-8 h-8 mx-auto mb-1 flex items-center justify-center">
                        <MdBugReport size={14} color="#10B981" />
                    </div>
                    <a
                        href={`${config.project_management_url}`}
                        className="text-xs text-green-600 hover:text-green-800 transition-colors duration-200 block"
                    >
                        Report a Bug
                    </a>
                </div>

                <div className="text-center p-2 bg-white rounded-lg shadow-sm">
                    <div className="bg-purple-100 p-1.5 rounded-full w-8 h-8 mx-auto mb-1 flex items-center justify-center">
                        <MdOutlineWeb size={14} color="#8B5CF6" />
                    </div>
                    <a
                        href={config.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-xs text-purple-600 hover:text-purple-800 transition-colors duration-200 block"
                    >
                        {config.website}
                    </a>
                </div>
            </div>

            <div className="text-center mt-3 pt-2 border-t border-gray-200">
                <p className="text-xs text-gray-500">
                    © {new Date().getFullYear()}{' '}
                    <a
                        href={config.website}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="font-medium text-gray-700 hover:text-blue-600 transition-colors duration-200"
                    >
                        {config.developer}
                    </a>
                </p>
            </div>
        </div>
    )
}
